import configs from "constants/configs";
import React, { useState } from "react";

const UploadCustomerImage = (props) => {
  let { image, onChange, Code } = props;

  const [selectedFile, setSelectedFile] = useState();
  let [imageFile, setImageFile] = useState("");
  if (image != imageFile) {
    setImageFile(image);
  }
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    const formData = new FormData();
    formData.append("File", event.target.files[0]);
    fetch(configs.apiUpload + "api/uploadfile/UploadImage?sCode=" + Code + "&sDuAn=Morman", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        setImageFile(result.FilePath);
        onChange(result.FilePath);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  if (!imageFile) imageFile = configs.apiViewUpload + "Image/icon-avatar-default.png";
  return (
    <div className="form-group row">
      <div className="col-md-6">
                     <img
                    id="ctl00_ContentPlaceHolder1_customerImage"
                    disabled="disabled"
                    className="img-responsive img-thong-tin-khach-hop-dong"
                    src={     
                      imageFile && imageFile.indexOf("http") > -1 ? imageFile
                      : imageFile.indexOf("/Upload/TaiSanImage/") > -1 ? configs.imageServer + imageFile
                        : configs.apiViewUpload + imageFile
                    }
                  />
      </div>

      <div className="dis-upload">
        <div className="col-md-9">
          <label className="btn">
            <img  src="/app-assets/images/icon-upload-img-v2.png"/>
            <input
              type="file"
              className="hidden"
              name="file"
              onChange={changeHandler}
            />
          </label>
        </div>
      </div>
    </div>
  );
};
export default UploadCustomerImage;
